import React from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import type { DownloadFileLimits } from '@/types/downloads'
import { familiesText, groupLabel } from './downloadFormatText'
import { fileFormatGroups, formatLimit } from './downloadUtils'

/** One line per group, from `fileLimits`, and a quiet toggle with every extension. */
export const DownloadFileFormats = ({ limits, className }: { limits?: DownloadFileLimits | null; className?: string }) => {
  const { t, i18n } = useTranslation('downloads')
  const [open, setOpen] = React.useState(false)
  const groups = fileFormatGroups(limits)
  const listId = React.useId()
  return (
    <div className={cn('space-y-1 text-xs text-gray-500', className)} data-testid="download-formats">
      {groups.map((group) => (
        <p key={group.key} data-testid="download-formats-line">
          <span className="font-medium text-gray-700">{groupLabel(t, group)}</span>
          {' '}({familiesText(t, group, i18n.language)}): {t('files.formats.upTo', { max: formatLimit(group.maxBytes, i18n.language) })}
        </p>
      ))}
      <button type="button" className="text-xs text-gray-500 underline underline-offset-2 hover:text-gray-700"
        aria-expanded={open} aria-controls={listId} onClick={(e) => { e.stopPropagation(); setOpen((v) => !v) }} data-testid="download-formats-toggle">
        {open ? t('files.formats.hideAll') : t('files.formats.showAll')}
      </button>
      {open && (
        <dl id={listId} className="mx-auto max-w-md space-y-1 pt-1 text-left" data-testid="download-formats-all">
          {groups.map((group) => (
            <div key={group.key}>
              <dt className="font-medium text-gray-700">{groupLabel(t, group)}</dt>
              <dd className="[overflow-wrap:anywhere]">{group.extensions.map((e) => `.${e}`).join(', ')}</dd>
            </div>
          ))}
        </dl>
      )}
    </div>
  )
}
